import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useIsOpenNow } from "@/components/LiveStatus";

const StickyCallButton = () => {
    const open = useIsOpenNow();
    return (
        <motion.a
            data-testid="sticky-call-button"
            href="tel:+33255992243"
            initial={{ opacity: 0, scale: 0.6, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 16 }}
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.94 }}
            className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-brand py-4 pl-5 pr-5 font-display font-bold text-white shadow-[0_10px_40px_rgba(27,67,189,0.5)] sm:pr-6"
            aria-label="Appeler Eradikbreizh au 02 55 99 22 43"
        >
            <span className="pulse-ring absolute inset-0 rounded-full bg-brand" aria-hidden="true" />
            <Phone className="relative h-5 w-5" />
            <span className="relative hidden flex-col sm:flex">
                <span className="text-sm leading-tight tracking-wide">02 55 99 22 43</span>
                <span data-testid="sticky-call-status" className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-widest text-white/85">
                    <span className={`h-1.5 w-1.5 rounded-full ${open ? "bg-green-300" : "bg-amber-300"}`} />
                    {open ? "Disponible maintenant" : "Rappel dès 9h00"}
                </span>
            </span>
        </motion.a>
    );
};

export default StickyCallButton;
